export default __webpack_public_path__ + "static/media/logo.dd3a7884.png";